import React from 'react';
import { useTranslation } from 'react-i18next';
import Page from 'Core/components/Page';
import { useScrollTop } from 'Core/hooks/useScrollTop';
import Card from 'Core/components/FormElements/Card';
import paperworkIllustration from 'Images/illustrations/paperwork.svg';

const ApplicationRefunded = () => {
  document.title = 'Payment Portal - Application Refunded';
  useScrollTop();
  const { t } = useTranslation();

  return (
    <Page title={t('easyCredit.page.financing.header')} withStepProgress={false} stickyFooter hideAlert>
      <div className="mt-12 max-w-4xl mx-auto">
        <Card className="bg-gradient-to-br from-white to-gray-50 shadow-xl border-0 overflow-hidden">
          {/* Top accent bar */}
          <div className="h-2 bg-gradient-to-r from-blue-400 via-indigo-400 to-blue-500"></div>

          <div className="p-8 md:p-12">
            <div className="flex flex-col md:flex-row items-center gap-8">
              {/* Illustration */}
              <div className="flex-shrink-0 w-40 md:w-56">
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-6 shadow-inner">
                  <img
                    src={paperworkIllustration}
                    alt="Feature coming soon"
                    className="w-full h-auto"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 text-center md:text-left">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-semibold mb-4">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                  </svg>
                  Feature Coming Soon
                </div>

                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight">
                  Refund Management
                </h2>

                <p className="text-lg text-gray-600 leading-relaxed mb-6">
                  We're currently processing your refund. This feature is being enhanced to provide you with more details and options.
                </p>

              </div>
            </div>
          </div>
        </Card>
      </div>
    </Page>
  );
};

export default ApplicationRefunded;

